
// Configuration de l'API YouTube

// Identifiants OAuth2 pour l'API YouTube
export const YOUTUBE_CLIENT_ID = "277114718137-1orrk1vfgpcp8si4s7tf5k2ajktg6d9k.apps.googleusercontent.com";
export const YOUTUBE_CLIENT_SECRET = "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";

// Portées (scopes) OAuth2 nécessaires pour les différentes fonctionnalités
export const YOUTUBE_SCOPES = [
  'https://www.googleapis.com/auth/youtube.readonly',          // Lecture seule des données YouTube
  'https://www.googleapis.com/auth/youtube.force-ssl',         // Accès sécurisé aux données YouTube
  'https://www.googleapis.com/auth/youtube.upload',            // Téléchargement de vidéos
  'https://www.googleapis.com/auth/youtube'                    // Gestion de la chaîne YouTube
  // Le scope youtube.partner a été retiré car il n'est pas disponible pour tous les comptes
  // Le scope youtube.channel-memberships.creator a été retiré car il n'est pas valide
];

// URI de redirection pour OAuth2 - Sélection automatique selon l'environnement
export const REDIRECT_URI = (() => {
  // En production (domaine Supabase)
  if (window.location.origin.includes('supabase.co')) {
    return "https://eledlxtrcasnxjjarfti.supabase.co/youtube-auth-callback";
  }
  // En développement local
  return `${window.location.origin}/youtube-auth-callback`;
})();

// Endpoints API YouTube
export const YOUTUBE_API_BASE_URL = 'https://www.googleapis.com/youtube/v3';
export const YOUTUBE_AUTH_URL = 'https://accounts.google.com/o/oauth2/v2/auth';
export const YOUTUBE_TOKEN_URL = 'https://oauth2.googleapis.com/token';

// Paramètres par défaut pour les requêtes API
export const DEFAULT_API_PARAMS = {
  part: 'snippet',
  maxResults: 50,
  mine: true,
};

// Configuration pour les commentaires
export const COMMENTS_CONFIG = {
  maxResults: 100,
  textFormat: 'plainText',
};

// Fonction pour générer l'URL d'autorisation OAuth2
export const generateAuthUrl = (state: string): string => {
  const scopeString = YOUTUBE_SCOPES.join(' ');
  
  const params = new URLSearchParams({
    client_id: YOUTUBE_CLIENT_ID,
    redirect_uri: REDIRECT_URI,
    response_type: 'code',
    scope: scopeString,
    access_type: 'offline',
    state: state,
    prompt: 'consent',
    include_granted_scopes: 'true'
  });
  
  return `${YOUTUBE_AUTH_URL}?${params.toString()}`;
};
